import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import BrandLogo from "@/components/BrandLogo";
import AuthField from "@/components/shared/AuthField";
import { friendlyError } from "@/lib/errors";
import { toast } from "sonner";

export default function Signup() {
  const nav = useNavigate();
  const { signup } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Sua senha precisa ter pelo menos 6 caracteres.");
      return;
    }
    setLoading(true);
    try {
      await signup(name, email, password);
      nav("/onboarding/brand-persona");
    } catch (err) {
      toast.error(friendlyError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen bg-brand-bg flex items-center justify-center px-6 py-12 relative overflow-hidden"
      data-testid="signup-page"
    >
      <div className="absolute inset-0 starfield opacity-90 pointer-events-none" />
      <div className="absolute inset-0 bloom-top pointer-events-none" />

      <div className="w-full max-w-md relative z-10">
        <div className="text-center mb-10">
          <Link to="/"><BrandLogo size="lg" /></Link>
        </div>
        <div className="glass-card rounded-3xl p-8 sm:p-10">
          <h1 className="font-display text-3xl text-white mb-2 tracking-tight">Comece sua marca</h1>
          <p className="text-[14px] text-brand-ink2 mb-7">
            Configure a Brand Persona e seu primeiro avatar por conversa.
          </p>
          <form onSubmit={onSubmit} className="space-y-5">
            <AuthField
              label="Seu nome" name="name" value={name} onChange={setName}
              testid="signup-name" autoComplete="name" required
            />
            <AuthField
              label="E-mail" type="email" name="email" value={email} onChange={setEmail}
              testid="signup-email" autoComplete="email" required
            />
            <AuthField
              label="Senha (mín. 6 caracteres)" type="password" name="password" value={password} onChange={setPassword}
              testid="signup-password" autoComplete="new-password" required
            />
            <button
              type="submit"
              data-testid="signup-submit"
              disabled={loading}
              className="pill-pink w-full py-3.5 text-[14px] tracking-wide"
            >
              {loading ? "Criando..." : "Criar conta"}
            </button>
            <p className="text-[12px] text-brand-ink3 text-center leading-relaxed font-ui">
              Ao criar a conta, você concorda com os{" "}
              <Link to="/termos" data-testid="signup-termos" className="text-brand-ink2 underline underline-offset-2 hover:text-brand-rose">
                Termos de Uso
              </Link>{" "}
              e com a{" "}
              <Link to="/privacidade" data-testid="signup-privacidade" className="text-brand-ink2 underline underline-offset-2 hover:text-brand-rose">
                Política de Privacidade
              </Link>.
            </p>
          </form>
          <p className="text-[13px] text-brand-ink2 mt-7 text-center font-ui">
            Já tem conta?{" "}
            <Link to="/login" className="text-brand-rose hover:text-brand-roseHover" data-testid="link-login">
              Entrar
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
